import React, { useEffect, useState } from "react";
import TopImage from "../../Assets/images/listing-bnr.webp";
import { ApiConstants } from "../../constants/ApiConstants";
import useMakeRequest from "../../utils/ApiHelper";
import { Link } from "react-router-dom";
import { PAGINATION } from "../../constants/Constants";
import { encodeID } from "../../utils/Helper";
import { useNavigate } from "react-router-dom";
import FrontLoader from "../layout/FrontLoader";
import { LanguageConstants } from "../../constants/LanguageConstants";
import { toast } from "react-toastify";
import { ProfileAction } from "../../redux/Action/Authaction";
import { useDispatch, useSelector } from "react-redux";

function UpdateCateory() {
  const [data, setData] = useState([]);
  const categoryList = useMakeRequest();
  const categoryAdd= useMakeRequest()
  const navigate = useNavigate();
  const [select_ids, setSelect_ids] = useState<any>([])
  const dispatch = useDispatch()
  const profiledata = useSelector((state: any) => state?.ProfileState)
  const [pagination, setPagination] = useState({
    page: PAGINATION.PAGE || 0,
    pageSize: PAGINATION.PAGESIZE || 10,
  });
  useEffect(() => {
    const payload = {
      page: pagination?.page,
      pageSize: pagination?.pageSize,
    };
    categoryList.makeRequest({
      payload,
      url: ApiConstants?.HomeCategory,
      toastStatus: false,
    });
  }, [pagination]);
  useEffect(() => {
    if (categoryList.status) {
      setData(categoryList?.data?.data?.rows);
    }
  }, [categoryList?.status]);
  useEffect(() => {
    if (
      categoryList?.data?.data?.count >= 10 &&
      pagination?.pageSize < categoryList?.data?.data?.count
    ) {
      const handleScroll = () => {
        if (
          window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 100
        ) {
          setPagination((prevPagination) => ({
            ...prevPagination,
            pageSize:
              prevPagination.pageSize < 20 ? 20 : prevPagination.pageSize,
          }));
        }
      };
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, [pagination]);

  const handleSelect = (id:any) => {
  setSelect_ids((prev:any) => {
    // if already selected → remove it
    if (prev.includes(id)) {
         if (prev.length === 1) {
              toast.error("At least one category must be selected");
              return prev;
            }
      return prev.filter((item:any) => item !== id);
    }
    // else add it
    return [...prev, id];
  });
};

const handelSubmit = ()=>{
    if(select_ids?.length == 0){
      return toast.error(LanguageConstants?.CATEGORY_SELECT_ERROR)
    }else{
        const payload = {
            cat_ids:select_ids,
            type:'update'
        }
      categoryAdd.makeRequest({payload,url: ApiConstants?.AddCategory,toastStatus: true});
    }
}

useEffect(()=>{
if(categoryAdd?.status){
    navigate('/')
}
},[categoryAdd?.status])

// useEffect(()=>{
//     if(profiledata?.data?.data){
//         const Ids:any = []
//         profiledata?.data?.data?.user_category?.map((res:any)=>{
//             Ids.push(res?.cat_id)
//         })
//         setSelect_ids(Ids)
//     }
// },[profiledata?.data?.data])

useEffect(() => {
  if (profiledata?.data?.data && data?.length > 0) {
    const profileIds = profiledata?.data?.data?.user_category?.map(
      (item: any) => item.cat_id
    );

    const categoryIds = data.map((item: any) => item.id);

    // only keep IDs which exist in category list
    const validIds = profileIds.filter((id: any) =>
      categoryIds.includes(id)
    );

    setSelect_ids(validIds);
  }
}, [profiledata?.data?.data, data]);

  return (
    <>
      {categoryList.loading || categoryAdd?.loading ? <FrontLoader /> : null}
      <main>
        {/* top banner section start */}
        <section
          className="main-banner small-banner"
          style={{ background: `url(${TopImage}) center/cover` }}
        >
          <div className="container">
            <h1 className="small-banner-heading">
              {LanguageConstants?.CATEGORY_SELECTION}
            </h1>
            <nav className="com-breadcrumb" aria-label="breadcrumb">
              
              <ol className="breadcrumb">
                <li className="breadcrumb-item" style={{color:'#BFBAD2'}} >{LanguageConstants?.CATEGORY_SELECT_MESSAGE}</li>
              </ol>
            </nav>
          </div>
        </section>
        {/* top banner section end  */}
        <div className="footer-space">
          <div className="container">
            <div className="row gy-4 gy-md-5">
              {data.length > 0 ? (
                data.map((res: any, i: any) => (
                  <div className="col-sm-6 col-lg-4 col-xl-3 content" key={i}>
                    <div className="categories">
                      <button className={select_ids?.includes(res?.id) ? "category-btn mw-100 active" : 'category-btn mw-100'} data-category="first"   onClick={() => handleSelect(res?.id)} >
                        {res?.category_details?.name}
                          {/* {select_ids?.includes(res?.id) && <span className="checkmark">✓</span>} */}
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <p>NO DATA</p>
              )}
            </div>
            <div className="row justify-content-center mt-5">   
                <div className="col-md-2">
            <button className="category-btn custom-width w-100" onClick={handelSubmit} >{LanguageConstants?.SAVE}</button>
                </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}



export default UpdateCateory